export const LEAVE_STATUS = {
    ALL: 'ALL',
    PENDING: 'PENDING',
    TL_APPROVED: 'TL_APPROVED',
    APPROVED: 'APPROVED',
    REJECTED: 'REJECTED',
    CANCELLED: 'CANCELLED',
    CANCELLATION_REQUESTED: 'CANCELLATION_REQUESTED'
};

export const LEAVE_STATUS_OPTIONS = [
    { label: 'All Status', value: LEAVE_STATUS.ALL },
    { label: 'Pending', value: LEAVE_STATUS.PENDING },
    { label: 'TL Approved', value: LEAVE_STATUS.TL_APPROVED },
    { label: 'Approved', value: LEAVE_STATUS.APPROVED },
    { label: 'Cancellation Requested', value: LEAVE_STATUS.CANCELLATION_REQUESTED },
    { label: 'Rejected', value: LEAVE_STATUS.REJECTED },
    { label: 'Cancelled', value: LEAVE_STATUS.CANCELLED }
];
